<script lang="ts" setup>
import PermissionLock from '../PermissionLock.vue';
import GroupLabel from '../GroupLabel.vue';
import { VChip } from 'vuetify/lib/components/index.mjs';
import { useLocale } from '../../composables/useLocale';

const { t } = useLocale();

defineProps<{
  groupName: string;
  yearsInSchool?: number | null;
  isDeletableOrErrorMessage?: string | false;
  to?: string;
  disabled?: boolean;
}>();

const emit = defineEmits<{
  (e: 'delete'): void;
  (e: 'gotoGroup'): void;
}>();
</script>

<template>
  <v-chip style="min-width: 100px" :to="to" link :disabled="disabled">
    <template #prepend>
      <v-icon :aria-label="`${t('lcp.go_to_group')} ${groupName}`" @click="emit('gotoGroup')" color="primary">
        mdi-account-multiple
      </v-icon>
    </template>
    <span
      tabindex="0"
      role="button"
      @click="emit('gotoGroup')"
      @keydown.enter="emit('gotoGroup')"
      style="cursor: pointer"
    >
      <GroupLabel :name="groupName" :years-in-school="yearsInSchool" size="small" />
    </span>
    <template v-if="!disabled" #append>
      <v-icon
        v-if="isDeletableOrErrorMessage === false"
        color="primary"
        :aria-label="`${t('lcp.remove')} ${groupName}`"
        @click="() => emit('delete')"
      >
        mdi-window-close
      </v-icon>
      <PermissionLock v-else :reason="isDeletableOrErrorMessage || undefined" color="primary" />
    </template>
  </v-chip>
</template>
